// The only name title a user can register with. The backend stores it lowercase, with a dot.
export const NAME_TITLE = 'dr.'

// Nationalities (country ids) where the family name comes first.
const FAMILY_NAME_FIRST_NATIONALITIES = [1, 1103, 1117, 1124]

// Any spelling of the dr title ("Dr.", "dr", "DR") becomes NAME_TITLE, like on the backend:
// the persisted profile may still hold an old spelling until it is refreshed.
const normalizeTitle = title => {
  const trimmed = title ? title.trim().toLowerCase() : ''
  return trimmed.replace(/\.+$/, '') === 'dr' ? NAME_TITLE : trimmed
}

// The single place where a user's name is composed for display: the title always
// goes after the name ("Kiss János dr.").
// Without nationalityId the Hungarian (family name first) order is used.
export const formatUserName = (user, { nationalityId } = {}) => {
  if (!user) {
    return ''
  }
  const familyNameFirst = nationalityId === undefined || FAMILY_NAME_FIRST_NATIONALITIES.includes(nationalityId)
  const names = familyNameFirst ? [user.familyName, user.firstName] : [user.firstName, user.familyName]
  return [...names, normalizeTitle(user.nameTitle)].filter(Boolean).join(' ')
}
